import React, {FunctionComponent} from "react";
import {Box, makeStyles} from "@material-ui/core";
import CheckBox from "./CheckBox";
import UnderlinedTextButton from "./UnderlinedTextButton";
import Text from "./Text";

type AgbCheckBoxProps = {
    checked: boolean;
    toggleChecked: () => void;
};

const useStyles = makeStyles(theme => ({
    checkBoxContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("xs")]: {
            width: 270,
            paddingLeft: 7
        }
    },
    agbLinkContainer: {
        marginRight: 3,
        marginLeft: 5,
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0
        }
    }
}));

const AgbCheckBox: FunctionComponent<AgbCheckBoxProps> = ({checked, toggleChecked}) => {

    const classes = useStyles();

    return (
        <Box className={classes.checkBoxContainer}>
            <CheckBox checked={checked} onClick={toggleChecked} className={classes.agbLinkContainer}/>
            <Box flexWrap={"wrap"} display={"flex"} alignItems={"center"}>
                <Text value={"Ich stimme den"} size={12}/>&nbsp;
                <div style={{display: "flex", flexDirection: "row"}}>
                    <UnderlinedTextButton
                        text={"AGB"}
                        href={"https://ankaufperpost.com/agb/"}
                        fontSize={12}
                    />
                    &nbsp;<Text value={"und"} size={12}/>&nbsp;
                    <UnderlinedTextButton
                        text={"Datenschutzbestimmungen"}
                        href={"https://ankaufperpost.com/datenschutz-2/"}
                        fontSize={12}
                    />
                    &nbsp;<Text value={"zu"} size={12}/>
                </div>
            </Box>
        </Box>
    );
};

export default AgbCheckBox;
